"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPrefiledTrackEvent = void 0;

var km_tracker_1 = require("@skbkontur/km-tracker");

var constants_1 = require("./constants");

var tracker;

var initializeTracker = function initializeTracker(siteID) {
  var isProd = ['kontur.ru', 'atlasnw.ru'].includes(window.location.hostname.split('.').slice(1).join('.'));
  var devMode = window.location.search.indexOf('__debug=true') !== -1;

  try {
    tracker = km_tracker_1.createTracker(siteID, isProd ? 'prod' : 'test', {
      catchPageVisits: false,
      catchEventsByAttributes: false,
      catchUnloadEvent: false
    }, devMode);
    return tracker;
  } catch (err) {
    console.error(err);
    return;
  }
};

exports.createPrefiledTrackEvent = function (trackEvent) {
  initializeTracker(constants_1.METRICS_SITE_ID);
  return function (action, label, parameters) {
    if (trackEvent) {
      try {
        var externalTrackEventResult = trackEvent(constants_1.METRICS_CATEGORY, action, label, parameters); // Недокументированная возможность.
        // Переданный параметр trackEvent может отключить "внутреннюю" отправку событий списка сертификатов.
        // Например на Аутхвебе отправляется много событий со списка сертификатов, и дублировать этот объем данных в метриках не хочется.

        if (externalTrackEventResult === 'skip') {
          return;
        }
      } catch (err) {
        console.error(err);
      }
    }

    try {
      tracker.trackEvent(constants_1.METRICS_CATEGORY, action, label, parameters);
    } catch (err) {
      console.error(err);
    }
  };
};